import type { UseFinancingData } from '../financings/useFinancing'
import type { PostPaymentModelBody, ReceiptModel } from '~/utils/receipt-model/ReceiptModel'
import { useMutation } from '@tanstack/vue-query'
import queryClient, { queryKeys } from '~/queryClient'
import { postPaymentModel } from '~/services-v2/payment-model-api/payment-model-api'

export function useUpdatePaymentModel(projectId: Ref<string>) {
  const mutationFn = async (inputs: PostPaymentModelBody) => {
    const response = await postPaymentModel(inputs)
    return response
  }

  return useMutation({
    mutationFn,
    mutationKey: queryKeys.PAYMENT_MODEL.UPDATE,
    retry: 2,
    retryDelay: 1000,
    onSuccess: () => {
      // Update the financing details in the query cache
      // to reflect the new payment model status
      queryClient.setQueryData<UseFinancingData>(queryKeys.FINANCING.DETAILS(projectId.value), (oldData) => {
        if (!oldData)
          return oldData

        return {
          ...oldData,
          section_statuses: {
            ...oldData.section_statuses,
            payment_model: {
              ...oldData.section_statuses.payment_model,
              status: 'under_analysis',
            },
          },
        }
      })

      queryClient.setQueryData<ReceiptModel>(queryKeys.PAYMENT_MODEL.DATA(projectId.value), (oldData) => {
        if (!oldData)
          return oldData

        return {
          ...oldData,
          status: 'under_analysis',
        }
      })

      queryClient.refetchQueries({ queryKey: queryKeys.PAYMENT_MODEL.DATA(projectId.value) })
      queryClient.refetchQueries({ queryKey: queryKeys.HARDWARE.FORM(projectId.value) })
    },
  })
}
